import Box from "@mui/material/Box";
import { IContentWithAnimation } from "../../shared/types";
import styles from "./index.module.scss";
import tp_fc_leftTop_bg from "../../assets/images/teachers-page/tp_fc_leftTop_bg.png";
import tp_fc_leftMiddle_bg from "../../assets/images/teachers-page/tp_fc_leftMiddle_bg.png";
import tp_fc_leftRight from "../../assets/images/teachers-page/tp_fc_leftRight.png";
import tp_fc_rightBottom from "../../assets/images/teachers-page/tp_fc_rightBottom.png";
import tp_fc_rightMiddle_bg from "../../assets/images/teachers-page/tp_fc_rightMiddle_bg.png";
import tp_fc_rightTop_bg from "../../assets/images/teachers-page/tp_fc_rightTop_bg.png";
import TeacherHeaderImage from "../../assets/images/teachers-page/Teacher_Clipped_Profile_Header.png";
import TeacherProfilePhoneAngle from "../../assets/images/teachers-page/Teacher_Profile_Phone_Screen.png";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import rightAngle from "../../assets/images/share/rightAngle.png";
import tp_sc_people from "../../assets/images/teachers-page/tp_sc_people.png";
import tp_sc_sticker from "../../assets/images/teachers-page/tp_sc_sticker.png";
import tp_sixC_bg from "../../assets/images/teachers-page/tp_sixC_bg.png";
import tp_sevenC_img from "../../assets/images/teachers-page/tp_sevenC_img.png";
import TeacherAvailabilityPhone from "../../assets/images/teachers-page/TeacherAvailabilityCalendarPhone.png";
import tp_eighC_leftBottom from "../../assets/images/teachers-page/tp_eighC_leftBottom.png";
import tp_eighC_leftCenter from "../../assets/images/teachers-page/tp_eighC_leftCenter.png";
import tp_eighC_rightTop from "../../assets/images/teachers-page/tp_eighC_rightTop.png";
import tp_eigthC_center from "../../assets/images/teachers-page/tp_eigthC_center.png";
import tp_eighC_device_ava from "../../assets/images/teachers-page/tp_eighC_device_ava.png";
import CarouselWrapper from "../../components/CarsouelWrapper";
import AnimationController from "../../components/AnimationController";
import StyledAccordion from "../../components/StyledAccordion";
import AppleButton from "../../components/SharedButtons/AppleButton";
import GooglePlayButton from "../../components/SharedButtons/GooglePlayButton";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Navigation, Autoplay, Pagination } from "swiper";
import { useNavigate } from "react-router-dom";
import { TabNames } from "../../routers/type";
import { ReactNode, useEffect, useState } from "react";
import {
  fadeIn,
  slideBasedOnLeft,
  slideBasedOnRight,
  transitionCubicBezier,
  slideBasedOnMarginTop,
  scaleUP,
  slideBasedOnMarginRight,
} from "../../shared/animations";
import { Divider, IconButton, Modal } from "@mui/material";
import pxToRem from "../../helpers/pxToRem";
import { AccountButton } from "../../components/Button";
import { modalStyle } from "../Dashboard/RegistrationModals";
import { BAND1_PAY, BAND2_PAY, BAND3_PAY } from "./constants";

export const TeacherPageFirstContent = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const navigate = useNavigate();
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Box
      sx={{ position: "relative" }}
      className={`${styles.TeacherPageFirstContent} flex_row_center`}
    >
      <img
        src={tp_fc_leftTop_bg}
        alt='tp_fc_leftTop_bg'
        className={styles.tp_fc_leftTop_bg}
        style={{
          ...slideBasedOnLeft(loadedAnimation, "0px", "-100px"),
        }}
      />
      <img
        src={tp_fc_leftMiddle_bg}
        alt='tp_fc_leftMiddle_bg'
        className={styles.tp_fc_leftMiddle_bg}
        style={{
          ...slideBasedOnLeft(loadedAnimation, "0px", "-100px"),
          transitionDelay: "0.3s",
        }}
      />
      <img
        src={tp_fc_leftRight}
        alt='tp_fc_leftRight'
        className={styles.tp_fc_leftRight}
        style={{
          ...slideBasedOnLeft(loadedAnimation, "526px", "626px"),
          transitionDelay: "0.6s",
        }}
      />
      <img
        src={TeacherHeaderImage}
        alt='Join Spark as a casual relief teacher'
        className={styles.tp_fc_device_circle}
        style={{
          ...fadeIn(loadedAnimation),
          ...transitionCubicBezier,
        }}
      />
      <img
        src={tp_fc_rightBottom}
        alt='tp_fc_rightBottom'
        className={styles.tp_fc_rightBottom}
        style={{
          ...slideBasedOnRight(loadedAnimation, "0px", "-100px"),
          transitionDelay: "0.6s",
        }}
      />
      <img
        src={tp_fc_rightMiddle_bg}
        alt='tp_fc_rightMiddle_bg'
        className={styles.tp_fc_rightMiddle_bg}
        style={{
          ...slideBasedOnRight(loadedAnimation, "0px", "-100px"),
          transitionDelay: "0.3s",
        }}
      />
      <img
        src={tp_fc_rightTop_bg}
        alt='tp_fc_rightTop_bg'
        className={styles.tp_fc_rightTop_bg}
        style={{
          ...slideBasedOnRight(loadedAnimation, "0px", "-100px"),
        }}
      />
      <Stack className={styles.tp_fc_container}>
        <Stack
          direction={"column"}
          className={`${styles.fc_text_stack} ${styles.fc_rightStack}`}
          alignItems={screenType === "MOBILE" ? "center" : "flex-end"}
        >
          <Box
            className={`${styles.fc_des} ${screenType === "PC"
              ? ""
              : screenType === "TABLET"
                ? "display_small"
                : "title_large"
              }`}
            sx={{
              width: screenType === "MOBILE" ? "100%" : "unset",
              ...slideBasedOnMarginTop(loadedAnimation, "0px", "500px"),
              transitionDelay: "0.2s",
            }}
          >
            {screenType === "MOBILE" ? (
              <>
                Join Spark as a  Casual Relief Teacher
              </>
            ) : (
              <>Join Spark as a Casual Relief Teacher</>
            )}
          </Box>
          <Button
            className={styles.fc_button}
            onClick={() =>
              navigate(
                `/${TabNames.REGISTER}`
              )
            }
          >
            <Stack direction={"row"} alignItems='center'>
              <Box
                className={`${styles.fcButtonText} ${screenType === "MOBILE"
                  ? "label_small medium_weight"
                  : "headLine_small semi_bold_weight"
                  }`}
              >
                Register Now
              </Box>
              <img
                src={rightAngle}
                alt='rightAngle'
                className={styles.fc_buttonIcon}
              />
            </Stack>
          </Button>
          <img
            className={styles.tp_fc_smallSize_device}
            src={TeacherProfilePhoneAngle}
            alt='Spark Relief Teachers Mobile Appliation Teacher Profile View'
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export const TeacherPageSecondContent = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  return (
    <>
      <Box className={`flex_row_center ${styles.TeacherPageSecondContent}`}>
        <Stack className={styles.scContainer} justifyContent='center'>
          <Box
            sx={{
              position: "relative",
              ...fadeIn(loadedAnimation),
              ...scaleUP(loadedAnimation),
              ...transitionCubicBezier,
            }}
            className={styles.tp_sc_left_panel}
          >
            <img
              src={tp_sc_people}
              alt='Earn more as a casual relief teacher with Spark'
              className={styles.tp_sc_people}
            />
            <img
              src={tp_sc_sticker}
              alt='tp_sc_stickerLeft'
              className={styles.tp_sc_stickerLeft}
            />
            <img
              src={tp_sc_sticker}
              alt='tp_sc_stickerRight'
              className={styles.tp_sc_stickerRight}
            />
          </Box>
          <Stack className={styles.tp_sc_rightStack} justifyContent='center'>
            <Box
              className={`${styles.SCTitle} heading1`}
              sx={{ textAlign: "center", color: `#ffba3b` }}
            >
              $421.58 + Super
            </Box>
            <Box
              className={`paragraph1 ${styles.tp_sc_text}`}
              sx={{
                marginTop: "25px",
                ...slideBasedOnMarginRight(loadedAnimation, "0px", "-100px"),
              }}
            >
              We pay our Teachers working in Victoria $421.58 plus super, per placement, in line with the Victorian Maximum Daily Rate.
              <br /><br />
              That means when you work with Spark, you'll receive the same rate you would if you engaged directly with a government school.
            </Box>
          </Stack>
        </Stack>
      </Box>
    </>
  );
}
export const TeacherPageSecondContentNSW = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Stack style={{ ...modalStyle, height: 'fit-content', width: pxToRem(1205), maxWidth: '95%', maxHeight: '95%', overflowX:'hidden' ,overflowY: 'scroll' }}>
          <Stack className={styles['payModal--btnContainer']}>
            <IconButton sx={{ alignSelf: 'flex-end' }} onClick={() => setOpen(false)}> <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M24 8L8 24M8 8L24 24" stroke="#555555" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /> </svg> </IconButton>
          </Stack>
          <Stack className={styles['payModal--mainContainer']}>
            <Stack gap={pxToRem(40)} className={styles.payRateModal}>
              <Stack>
                <h3>Our Pay Rates</h3>
                <p>When you work with Spark, you earn above the rate that you would receive if you were engaged directly by a government school. Our pay rates are applicable for any full-day placement that you complete through Spark at any School in New South Wales. </p>
              </Stack>
              <table className={styles['payRateTable--modal']}>
                <tr>
                  <th>Band 1</th>
                  <th>Band 2</th>
                  <th>Band 3</th>
                </tr>
                <tr>
                  <td>${BAND1_PAY} + super</td>
                  <td>${BAND2_PAY} + super</td>
                  <td>${BAND3_PAY} + super</td>
                </tr>
              </table>
              <Stack className={styles.nswBanner}>
                <Stack>
                  <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="60" cy="60" r="54" fill="#A54D9D" stroke="#F1D8EA" strokeWidth="12" /> <path d="M85 41.25L50.625 75.625L35 60" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" /> </svg>
                  <Stack flex={1}>
                    <h1>We take care of teacher payroll</h1>
                    <Divider flexItem />
                  </Stack>
                </Stack>
                <p>Spark employs our teachers as our casual employees, which means we take care of payroll so there's less hassle for you. You'll receive a weekly payslip from us for all the bookings you completed the week prior – no need to share your payment details with every school you work at.</p>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Modal>
      <Box className={`flex_row_center ${styles.TeacherPageSecondContent}`}>
        <Stack className={styles.scContainer} justifyContent='center'>
          <Box
            sx={{
              position: "relative",
              ...fadeIn(loadedAnimation),
              ...scaleUP(loadedAnimation),
              ...transitionCubicBezier,
            }}
            className={styles.tp_sc_left_panel}
          >
            <img
              src={tp_sc_people}
              alt='Earn more as a casual relief teacher with Spark'
              className={styles.tp_sc_people}
            />
            <img
              src={tp_sc_sticker}
              alt='tp_sc_stickerLeft'
              className={styles.tp_sc_stickerLeft}
            />
            <img
              src={tp_sc_sticker}
              alt='tp_sc_stickerRight'
              className={styles.tp_sc_stickerRight}
            />
          </Box>
          <Stack className={styles.tp_sc_rightStack} justifyContent='center'>
            <Box
              className={`${styles.SCTitle} heading1`}
              sx={{ textAlign: "center", color: `#ffba3b` }}
            >
              Earn More with Spark
            </Box>
            <Box
              className={`paragraph1 ${styles.tp_sc_text}`}
              sx={{
                marginTop: "25px",
                ...slideBasedOnMarginRight(loadedAnimation, "0px", "-100px"),
              }}
            >
              We're committed to paying above the government rate of pay for all of our Teachers working in New South Wales. Learn more about our rates below.
            </Box>
            <AccountButton onClick={() => setOpen(true)} sx={{ marginTop: pxToRem(40), padding: `${pxToRem(16)} ${pxToRem(12)} !important`, width: `${pxToRem(240)} !important`, maxWidth: `${pxToRem(240)} !important`, alignSelf: 'center' }}>View our Pay Rates</AccountButton>
          </Stack>
        </Stack>
      </Box>
    </>
  );
}

export const TeacherPageThirdContent = ({
  loadedAnimation
}: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack className={`${styles.tp_thirdContent} flex_row_center`}>
      <Stack
        className={`${styles.tp_thirdContent_container}`}
        justifyContent='center'
      >
        <Box
          className={`${styles.neutral_10} heading1`}
          sx={{
            // textAlign: screenType === "PC" ? "left" : "center",
            textAlign: "center",
            ...fadeIn(loadedAnimation),
            ...transitionCubicBezier,
          }}
        >
          Why CRT with Spark?
        </Box>
      </Stack>
    </Stack>
  );
};
export const TeacherPageThirdContentNSW = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack className={`${styles.tp_thirdContent} flex_row_center`}>
      <Stack
        className={`${styles.tp_thirdContent_container}`}
        justifyContent='center'
      >
        <Box
          className={`${styles.neutral_10} heading1`}
          sx={{
            // textAlign: screenType === "PC" ? "left" : "center",
            textAlign: "center",
            ...fadeIn(loadedAnimation),
            ...transitionCubicBezier,
          }}
        >
          Why teach with Spark?
        </Box>
      </Stack>
    </Stack>
  );
};

interface ITeacherPageForthContentCard {
  imgElement: JSX.Element;
  title: string;
  desElement: JSX.Element;
  color?: string;
}

const TeacherPageForthContentCard = ({
  imgElement,
  title,
  desElement,
  color
}: ITeacherPageForthContentCard) => (
  <Stack
    className={styles.TeacherPageForthContentCard}
    direction='column'
    alignItems='center'
    justifyContent='flex-start'
    sx={{ backgroundColor: color }}
  >
    {/* <Box style={{height: '80px', width: '100%', overflow: 'hidden'}}> */}
    {imgElement}
    {/* </Box> */}
    <Box className={`${styles.TeacherPageForthContentCardText} heading2`}>
      {title}
    </Box>
    <Box
      className={`${styles.TeacherPageForthContentCardText} paragraph2 medium_weight`}
    >
      {desElement}
    </Box>
  </Stack>
);

export const TeacherPageForthContent = ({
  loadedAnimation
}: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <>
      <Stack sx={{ width: '100%' }} alignItems={'center'}>
        <Stack direction={screenType==='MOBILE' ? 'column': 'row'} gap={pxToRem(40)} justifyContent={'center'} padding={`${pxToRem(0)} ${pxToRem(40)}`} maxWidth={pxToRem(1300)}>
          <Stack alignSelf={'stretch'} flex={1} sx={{ ...slideBasedOnMarginTop(loadedAnimation, "0px", "-100px") }}>
            <TeacherPageForthContentCard
              imgElement={<svg width="132" height="121" viewBox="0 0 132 121" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13.5 108.267V49.9334H38.5V41.6001L51 29.1001L63.5 41.6001V66.6001H88.5V108.267H13.5ZM21.8333 99.9334H30.1667V91.6001H21.8333V99.9334ZM21.8333 83.2668H30.1667V74.9334H21.8333V83.2668ZM21.8333 66.6001H30.1667V58.2668H21.8333V66.6001ZM46.8333 99.9334H55.1667V91.6001H46.8333V99.9334ZM46.8333 83.2668H55.1667V74.9334H46.8333V83.2668ZM46.8333 66.6001H55.1667V58.2668H46.8333V66.6001ZM46.8333 49.9334H55.1667V41.6001H46.8333V49.9334ZM71.8333 99.9334H80.1667V91.6001H71.8333V99.9334ZM71.8333 83.2668H80.1667V74.9334H71.8333V83.2668Z" fill="white" /> <path d="M91.4997 41.3001C93.333 41.3001 94.903 40.6293 96.2097 39.2878C97.5163 37.9463 98.1686 36.3356 98.1663 34.4557C98.1663 32.5734 97.513 30.9616 96.2063 29.6201C94.8997 28.2785 93.3308 27.6089 91.4997 27.6112C89.6663 27.6112 88.0963 28.282 86.7897 29.6235C85.483 30.965 84.8308 32.5757 84.833 34.4557C84.833 36.3379 85.4863 37.9497 86.793 39.2913C88.0997 40.6328 89.6686 41.3024 91.4997 41.3001ZM91.4997 75.5223C82.5552 67.7082 75.8752 60.4509 71.4597 53.7501C67.0441 47.0494 64.8352 40.8461 64.833 35.1401C64.833 26.5845 67.5141 19.7686 72.8763 14.6923C78.2386 9.61603 84.4463 7.07788 91.4997 7.07788C98.5552 7.07788 104.764 9.61603 110.126 14.6923C115.489 19.7686 118.169 26.5845 118.166 35.1401C118.166 40.8438 115.957 47.0472 111.54 53.7501C107.122 60.4531 100.442 67.7105 91.4997 75.5223Z" fill="white" /> </svg>}
              title={"Location-Based Placements"}
              desElement={
                <span>
                  Update your own location at any time in the mobile app.
                  <br />
                  <br />
                  Update your location in Victoria at any time to receive requests
                  from nearby schools in that area.
                </span>
              }
              color={styles.secondaryBlue700}
            />
          </Stack>
          <Stack alignSelf={'stretch'} flex={1} sx={{
            ...slideBasedOnMarginTop(loadedAnimation, "0px", "-100px"),
            transitionDelay: "0.3s",
          }}>
            <TeacherPageForthContentCard
              imgElement={<svg width="101" height="121" viewBox="0 0 101 121" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M91.125 32.375H75.5V26.9062C75.5 26.4766 75.1484 26.125 74.7188 26.125H69.25C68.8203 26.125 68.4688 26.4766 68.4688 26.9062V32.375H54.0156V26.9062C54.0156 26.4766 53.6641 26.125 53.2344 26.125H47.7656C47.3359 26.125 46.9844 26.4766 46.9844 26.9062V32.375H32.5312V26.9062C32.5312 26.4766 32.1797 26.125 31.75 26.125H26.2812C25.8516 26.125 25.5 26.4766 25.5 26.9062V32.375H9.875C8.14648 32.375 6.75 33.7715 6.75 35.5V91.75C6.75 93.4785 8.14648 94.875 9.875 94.875H91.125C92.8535 94.875 94.25 93.4785 94.25 91.75V35.5C94.25 33.7715 92.8535 32.375 91.125 32.375ZM41.9062 77.6875C41.9062 78.1172 41.5547 78.4688 41.125 78.4688H23.1562C22.7266 78.4688 22.375 78.1172 22.375 77.6875V73C22.375 72.5703 22.7266 72.2188 23.1562 72.2188H41.125C41.5547 72.2188 41.9062 72.5703 41.9062 73V77.6875ZM41.9062 64.4062C41.9062 64.8359 41.5547 65.1875 41.125 65.1875H23.1562C22.7266 65.1875 22.375 64.8359 22.375 64.4062V59.7188C22.375 59.2891 22.7266 58.9375 23.1562 58.9375H41.125C41.5547 58.9375 41.9062 59.2891 41.9062 59.7188V64.4062ZM78.4785 55.4902L62.3652 77.8242C62.2214 78.0239 62.0321 78.1865 61.8131 78.2986C61.5941 78.4107 61.3515 78.4692 61.1055 78.4692C60.8594 78.4692 60.6169 78.4107 60.3978 78.2986C60.1788 78.1865 59.9896 78.0239 59.8457 77.8242L48.6934 62.375C48.3223 61.8574 48.6934 61.1348 49.3281 61.1348H54.6895C55.1875 61.1348 55.6562 61.3789 55.9492 61.7793L61.1055 68.918L71.2324 54.8848C71.5254 54.4746 71.9941 54.2402 72.4922 54.2402H77.8438C78.4785 54.25 78.8496 54.9727 78.4785 55.4902Z" fill="white" /> </svg>}
              title={"Flexibility"}
              desElement={
                <span>
                  Manage your own availability at any time, no need to call.
                  <br />
                  <br />
                  You can manage your availability in the app for the current school term as well as the next term.
                </span>
              }
              color={styles.secondaryBlue800}
            />
          </Stack>
          <Stack alignSelf={'stretch'} flex={1} sx={{
            ...slideBasedOnMarginTop(loadedAnimation, "0px", "-100px"),
            transitionDelay: "0.6s",
          }}>
            <TeacherPageForthContentCard
              imgElement={<svg width="101" height="121" viewBox="0 0 101 121" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_145_1143" maskUnits="userSpaceOnUse" x="45" y="20" width="41" height="40">
                <path d="M45.3018 20H85.2878V59.672H45.3018V20Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_145_1143)">
                <path d="M65.278 59.5464C76.1811 59.5464 85.0503 50.6789 85.0503 39.7775C85.0503 28.8743 76.1811 20.0068 65.278 20.0068C54.3765 20.0068 45.5073 28.8743 45.5073 39.7775C45.5073 50.6789 54.3765 59.5464 65.278 59.5464ZM48.7959 39.7775C48.7959 30.6876 56.1897 23.2937 65.278 23.2937C74.3679 23.2937 81.7617 30.6876 81.7617 39.7775C81.7617 48.8657 74.3679 56.2595 65.278 56.2595C56.1897 56.2595 48.7959 48.8657 48.7959 39.7775Z" fill="white"/>
                </g>
                <path d="M60.4496 48.8317C61.3035 49.6653 62.441 50.2511 63.6923 50.5108L63.6787 52.2578C63.6719 53.139 64.385 53.8622 65.2661 53.869H65.278C66.1541 53.869 66.8706 53.156 66.8773 52.2816L66.8909 50.5057C68.1371 50.2426 69.2712 49.6534 70.1201 48.8198C71.1048 47.8521 71.6481 46.6127 71.6481 45.3309V44.6246C71.6481 42.9201 70.6889 41.3089 69.0811 40.314L63.3782 36.7826C62.7093 36.3683 62.3273 35.7894 62.3273 35.1918V34.0865C62.3273 33.55 62.6244 33.0339 63.1643 32.6332C63.7534 32.1969 64.5429 31.9558 65.3884 31.9558C66.2339 31.9558 67.0234 32.1952 67.6125 32.6332C68.1524 33.0339 68.4495 33.55 68.4495 34.0865V35.3327C68.4495 36.2155 69.1676 36.932 70.0488 36.932C70.9316 36.932 71.6481 36.2155 71.6481 35.3327V34.0865C71.6481 31.6519 69.7143 29.545 66.9877 28.9338V27.2835C66.9877 26.4024 66.2695 25.6842 65.3884 25.6842C64.5055 25.6842 63.7891 26.4024 63.7891 27.2835V28.9338C61.0608 29.545 59.127 31.6502 59.127 34.0865V35.1918C59.127 36.8963 60.0879 38.5075 61.694 39.5024L67.3969 43.0321C68.0658 43.4464 68.4495 44.027 68.4495 44.6246V45.3309C68.4495 45.8674 68.1524 46.3835 67.6125 46.7842C67.0234 47.2222 66.2339 47.4616 65.3884 47.4616H65.1711C64.3256 47.4616 63.5361 47.2222 62.947 46.7842C62.4071 46.3835 62.1083 45.8674 62.1083 45.3309V44.6433C62.1083 43.7621 61.3918 43.044 60.509 43.044C59.6278 43.044 58.9097 43.7621 58.9097 44.6433V45.3309C58.9097 46.6195 59.4564 47.8623 60.4496 48.8317Z" fill="white"/>
                <mask id="mask1_145_1143" maskUnits="userSpaceOnUse" x="1" y="60" width="100" height="41">
                <path d="M1 60.9758H100.5V100.424H1V60.9758Z" fill="white"/>
                </mask>
                <g mask="url(#mask1_145_1143)">
                <path d="M96.3283 71.1133L70.1656 92.4595C67.8803 94.3237 65.2013 95.6462 62.3303 96.3185C56.6428 97.6479 51.9535 97.1114 45.4578 94.7057C45.434 94.6955 45.4086 94.687 45.3831 94.6785L25.0182 88.2133C24.8536 88.1607 24.6804 88.1336 24.5055 88.1336H18.4427V68.8892H24.5072C24.7432 68.8892 24.9775 68.8383 25.1948 68.7432L28.3629 67.3341C34.8348 64.458 42.1811 65.2118 48.0758 69.3442C49.2574 71.0913 51.1284 72.1218 53.1487 72.1218H69.4542C70.9788 72.1218 72.2402 73.5089 72.2691 75.2152C72.2844 76.1574 71.9448 77.0522 71.337 77.6701C71.0382 77.974 70.6885 78.1948 70.3167 78.3187C69.8345 78.3968 69.3455 78.4358 68.8515 78.4358H50.7141C49.7837 78.4358 49.0078 79.1761 48.996 80.1065C48.9841 81.0504 49.7464 81.8212 50.6886 81.8212H69.5985C70.1078 81.8212 70.6087 81.7533 71.0909 81.6209C73.2012 81.2406 75.1927 80.3187 76.9448 78.9027L92.4829 66.3341C92.4964 66.3222 92.51 66.312 92.5236 66.3001C93.617 65.3545 95.1263 65.4665 96.1127 66.5633C97.2044 67.7755 97.2893 69.7823 96.3283 71.1133Z" fill="white"/>
                <path d="M15.0574 92.5121H4.38683V64.5922H15.0574V92.5121Z" fill="white"/>
                </g>
                </svg>
                }
              title={"Maximum Pay"}
              desElement={
                <span> Teachers working with Spark are guaranteed the maximum daily rate of pay set by the Victorian Government. </span>
              }
              color={styles.secondaryBlue900}
            />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};
export const TeacherPageForthContentNSW = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
      <Stack sx={{ width: '100%' }} alignItems={'center'}>
        <Stack direction={screenType==='MOBILE' ? 'column': 'row'} gap={pxToRem(40)} justifyContent={'center'} padding={`${pxToRem(0)} ${pxToRem(40)}`} maxWidth={pxToRem(1300)}>
          <Stack alignSelf={'stretch'} flex={1} sx={{ ...slideBasedOnMarginTop(loadedAnimation, "0px", "-100px") }}>
            <TeacherPageForthContentCard
              imgElement={<svg width="132" height="121" viewBox="0 0 132 121" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13.5 108.267V49.9334H38.5V41.6001L51 29.1001L63.5 41.6001V66.6001H88.5V108.267H13.5ZM21.8333 99.9334H30.1667V91.6001H21.8333V99.9334ZM21.8333 83.2668H30.1667V74.9334H21.8333V83.2668ZM21.8333 66.6001H30.1667V58.2668H21.8333V66.6001ZM46.8333 99.9334H55.1667V91.6001H46.8333V99.9334ZM46.8333 83.2668H55.1667V74.9334H46.8333V83.2668ZM46.8333 66.6001H55.1667V58.2668H46.8333V66.6001ZM46.8333 49.9334H55.1667V41.6001H46.8333V49.9334ZM71.8333 99.9334H80.1667V91.6001H71.8333V99.9334ZM71.8333 83.2668H80.1667V74.9334H71.8333V83.2668Z" fill="white" /> <path d="M91.4997 41.3001C93.333 41.3001 94.903 40.6293 96.2097 39.2878C97.5163 37.9463 98.1686 36.3356 98.1663 34.4557C98.1663 32.5734 97.513 30.9616 96.2063 29.6201C94.8997 28.2785 93.3308 27.6089 91.4997 27.6112C89.6663 27.6112 88.0963 28.282 86.7897 29.6235C85.483 30.965 84.8308 32.5757 84.833 34.4557C84.833 36.3379 85.4863 37.9497 86.793 39.2913C88.0997 40.6328 89.6686 41.3024 91.4997 41.3001ZM91.4997 75.5223C82.5552 67.7082 75.8752 60.4509 71.4597 53.7501C67.0441 47.0494 64.8352 40.8461 64.833 35.1401C64.833 26.5845 67.5141 19.7686 72.8763 14.6923C78.2386 9.61603 84.4463 7.07788 91.4997 7.07788C98.5552 7.07788 104.764 9.61603 110.126 14.6923C115.489 19.7686 118.169 26.5845 118.166 35.1401C118.166 40.8438 115.957 47.0472 111.54 53.7501C107.122 60.4531 100.442 67.7105 91.4997 75.5223Z" fill="white" /> </svg>}
              title={"Location-Based Placements"}
              desElement={
                <span>
                  Update your own location at any time in the mobile app.
                  <br />
                  <br />
                  Set a custom location anywhere in New South Wales to receive booking requests from nearby schools in that area.
                </span>
              }
              color={styles.secondaryBlue700}
            />
          </Stack>
          <Stack alignSelf={'stretch'} flex={1} sx={{
            ...slideBasedOnMarginTop(loadedAnimation, "0px", "-100px"),
            transitionDelay: "0.3s",
          }}>
            <TeacherPageForthContentCard
              imgElement={<svg width="101" height="121" viewBox="0 0 101 121" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M91.125 32.375H75.5V26.9062C75.5 26.4766 75.1484 26.125 74.7188 26.125H69.25C68.8203 26.125 68.4688 26.4766 68.4688 26.9062V32.375H54.0156V26.9062C54.0156 26.4766 53.6641 26.125 53.2344 26.125H47.7656C47.3359 26.125 46.9844 26.4766 46.9844 26.9062V32.375H32.5312V26.9062C32.5312 26.4766 32.1797 26.125 31.75 26.125H26.2812C25.8516 26.125 25.5 26.4766 25.5 26.9062V32.375H9.875C8.14648 32.375 6.75 33.7715 6.75 35.5V91.75C6.75 93.4785 8.14648 94.875 9.875 94.875H91.125C92.8535 94.875 94.25 93.4785 94.25 91.75V35.5C94.25 33.7715 92.8535 32.375 91.125 32.375ZM41.9062 77.6875C41.9062 78.1172 41.5547 78.4688 41.125 78.4688H23.1562C22.7266 78.4688 22.375 78.1172 22.375 77.6875V73C22.375 72.5703 22.7266 72.2188 23.1562 72.2188H41.125C41.5547 72.2188 41.9062 72.5703 41.9062 73V77.6875ZM41.9062 64.4062C41.9062 64.8359 41.5547 65.1875 41.125 65.1875H23.1562C22.7266 65.1875 22.375 64.8359 22.375 64.4062V59.7188C22.375 59.2891 22.7266 58.9375 23.1562 58.9375H41.125C41.5547 58.9375 41.9062 59.2891 41.9062 59.7188V64.4062ZM78.4785 55.4902L62.3652 77.8242C62.2214 78.0239 62.0321 78.1865 61.8131 78.2986C61.5941 78.4107 61.3515 78.4692 61.1055 78.4692C60.8594 78.4692 60.6169 78.4107 60.3978 78.2986C60.1788 78.1865 59.9896 78.0239 59.8457 77.8242L48.6934 62.375C48.3223 61.8574 48.6934 61.1348 49.3281 61.1348H54.6895C55.1875 61.1348 55.6562 61.3789 55.9492 61.7793L61.1055 68.918L71.2324 54.8848C71.5254 54.4746 71.9941 54.2402 72.4922 54.2402H77.8438C78.4785 54.25 78.8496 54.9727 78.4785 55.4902Z" fill="white" /> </svg>}
              title={"Flexibility"}
              desElement={
                <span>
                  Manage your own availability at any time, no need to call.
                  <br />
                  <br />
                  You can manage your availability in the app for the current school term as well as the next term.
                </span>
              }
              color={styles.secondaryBlue800}
            />
          </Stack>
          <Stack alignSelf={'stretch'} flex={1} sx={{
            ...slideBasedOnMarginTop(loadedAnimation, "0px", "-100px"),
            transitionDelay: "0.6s",
          }}>
            <TeacherPageForthContentCard
              imgElement={<svg width="101" height="121" viewBox="0 0 101 121" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.45843 34.8076C9.45843 38.3546 12.409 41.368 16.0188 41.368C19.6286 41.368 22.6106 38.3546 22.6106 34.8076C22.6106 31.1664 19.6286 28.2158 16.0188 28.2158C12.409 28.2158 9.45843 31.1664 9.45843 34.8076ZM78.4526 34.8076C78.4526 38.3546 81.4032 41.368 84.9816 41.368C88.5914 41.368 91.5734 38.3546 91.5734 34.8076C91.5734 31.1664 88.5914 28.2158 84.9816 28.2158C81.4032 28.2158 78.4526 31.1664 78.4526 34.8076ZM1.70522 68.7083C1.67383 70.5917 2.80385 71.6903 4.40472 71.6903C6.00558 71.6903 7.1356 70.5917 7.1356 68.7083V55.5561C7.1356 54.8341 7.51228 54.3947 8.07729 54.3947C8.6423 54.3947 9.01897 54.8341 9.01897 55.5561V89.5195C9.01897 91.654 10.3059 92.784 12.0638 92.784C13.8216 92.784 15.1085 91.654 15.1085 89.5195V68.363C15.1085 67.6724 15.4538 67.2016 16.0188 67.2016C16.5525 67.2016 16.9291 67.6724 16.9291 68.363V89.5195C16.9291 91.654 18.2161 92.784 19.9739 92.784C21.7317 92.784 23.0501 91.654 23.0501 89.5195V55.5561C23.0501 54.8341 23.3326 54.3947 23.929 54.3947C24.5254 54.3947 24.8707 54.8341 24.8707 55.5561L24.9021 68.7083C24.8707 70.5917 26.0321 71.6903 27.633 71.6903C29.2338 71.6903 30.3324 70.5917 30.3324 68.7083V55.87C30.3324 47.3948 25.5612 44.0361 16.0188 44.0361C6.47642 44.0361 1.67383 47.3948 1.67383 55.87L1.70522 68.7083ZM70.668 68.7083C70.668 70.5917 71.798 71.6903 73.3989 71.6903C74.9683 71.6903 76.1297 70.5917 76.1297 68.7083V55.5561C76.1297 54.8341 76.5064 54.3947 77.0714 54.3947C77.6678 54.3947 77.9817 54.8341 77.9817 55.5561V89.5195C77.9817 91.654 79.3001 92.784 81.0579 92.784C82.8157 92.784 84.0713 91.654 84.0713 89.5195V68.363C84.0713 67.6724 84.4794 67.2016 84.9816 67.2016C85.578 67.2016 85.8919 67.6724 85.8919 68.363V89.5195C85.8919 91.654 87.2102 92.784 88.968 92.784C90.7259 92.784 91.9814 91.654 91.9814 89.5195V55.5561C91.9814 54.8341 92.3581 54.3947 92.9231 54.3947C93.4881 54.3947 93.8962 54.8341 93.8962 55.5561V68.7083C93.8962 70.5917 95.0262 71.6903 96.6271 71.6903C98.228 71.6903 99.3266 70.5917 99.3266 68.7083V55.87C99.3266 47.3948 94.524 44.0361 84.9816 44.0361C75.4392 44.0361 70.668 47.3948 70.668 55.87V68.7083ZM38.2112 64.659C40.5654 64.659 42.4488 62.8071 42.4488 60.4528C42.4488 58.0986 40.5654 56.2153 38.2112 56.2153C35.857 56.2153 33.9736 58.0986 33.9736 60.4528C33.9736 62.8071 35.857 64.659 38.2112 64.659ZM50.5473 64.659C52.8701 64.659 54.7535 62.8071 54.7535 60.4528C54.7535 58.0986 52.8701 56.2153 50.5473 56.2153C48.1931 56.2153 46.3097 58.0986 46.3097 60.4528C46.3097 62.8071 48.1931 64.659 50.5473 64.659ZM62.8206 64.659C65.1748 64.659 67.0582 62.8071 67.0582 60.4528C67.0582 58.0986 65.1748 56.2153 62.8206 56.2153C60.4978 56.2153 58.6144 58.0986 58.6144 60.4528C58.6144 62.8071 60.4978 64.659 62.8206 64.659Z" fill="white" /> </svg>}
              title={"Better Networks"}
              desElement={
                <span>
                  Increase your exposure and connect with more schools across New South Wales.
                  <br /><br />
                  Explore working opportunities with ease on the Spark app.
                </span>
              }
              color={styles.secondaryBlue900}
            />
          </Stack>
        </Stack>
      </Stack>
  );
};

interface ITeacherPageFifthContentSlide {
  imageUrl: string;
  imgAlt: string;
  title: string;
  des: ReactNode;
}

const TeacherPageFifthContentSlide = ({
  imageUrl,
  imgAlt,
  title,
  des,
}: ITeacherPageFifthContentSlide) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack
      direction={screenType === "MOBILE" ? "column" : "row"}
      justifyContent='center'
      alignItems={"center"}
      className={styles.TeacherPageFifthContentSlide}
    >
      <img
        src={imageUrl}
        alt={imgAlt}
        className={styles.TeacherPageFifthContentSlide_img}
      />
      <Stack
        direction={"column"}
        className={styles.TeacherPageFifthContentSlide_stack}
      >
        <Box
          className={`heading2 ${styles.TeacherPageFifthContentSlide_title}`}
        >
          {title}
        </Box>
        <Box
          className={`${styles.TeacherPageFifthContentSlide_para} paragraph2`}
        >
          {des}
        </Box>
      </Stack>
    </Stack>
  );
};
interface ITeacherPageFifthContent extends IContentWithAnimation {
  config: {
    imageUrl: string;
    imgAlt: string;
    title: string;
    buttonBgImg: string;
    des: ReactNode;
  }[];
}

export const TeacherPageFifthContent = ({
  loadedAnimation,
  config,
}: ITeacherPageFifthContent) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const screenType = useSelector((state: RootState) => state.ui.screenType);
  // autoPlay will be disabled after users select any slides mannually
  const [disableAutoPlay, setDisableAutoPlay] = useState(true);

  useEffect(() => {
    if (loadedAnimation) {
      setDisableAutoPlay(false);
    }
  }, [loadedAnimation]);

  return (
    <Stack className='flex_row_center TeacherPageFifthContent'>
      <Stack
        className={`${styles.TeacherPageFifthContentContainer}`}
        justifyContent='center'
        alignItems='center'
        sx={{
          ...fadeIn(loadedAnimation),
          ...scaleUP(loadedAnimation),
          ...transitionCubicBezier,
        }}
      >
        <Box
          className={`${screenType === "PC"
            ? "display_medium bold_weight"
            : `${screenType === "TABLET" ? "headLine_medium" : "headLine_small"
            } semi_bold_weight`
            }`}
        >
          How It Works
        </Box>
        <Stack direction={"row"} className={styles.tp_fifC_bannerStack}>
          {config.map((c, index) => (
            <img
              key={`slide-button-${index}`}
              src={c.buttonBgImg}
              alt={`tp_fif_banner_blue_${index}`}
              className={`${styles.tp_fifC_banner_image} ${activeSlideIndex === index
                ? styles["tp_fifC_banner_button--active"]
                : styles["tp_fifC_banner_button-unActive"]
                }`}
              onClick={() => {
                if (!disableAutoPlay) {
                  setDisableAutoPlay(true);
                }
                setActiveSlideIndex(index);
              }}
            />
          ))}
        </Stack>
        <Box className={styles.tp_fifC_carsouel_wrapper}>
          <CarouselWrapper
            swiperModules={[Navigation, Pagination, Autoplay]}
            activeSlideIndex={activeSlideIndex}
            setAcitiveSlideIndex={(index: number) => setActiveSlideIndex(index)}
            disableNavigation
            disableLoop
            disableAutoPlay={disableAutoPlay}
            delay={5000}
          >
            {config.map((config, index) => (
              <div key={`carsouel-slide-${index}`}>
                <AnimationController
                  render={(loadedAnimation: boolean) => (
                    <TeacherPageFifthContentSlide {...config} />
                  )}
                />
              </div>
            ))}
          </CarouselWrapper>
        </Box>
      </Stack>
    </Stack>
  );
};

export const TeacherPageSixthContent = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const navigate = useNavigate();

  return (
    <Stack className='flex_row_center'>
      <img
        src={tp_sixC_bg}
        alt='tp_sixC_bg'
        className={styles.TeacherPageSixthContentImg}
      />
      <Stack
        direction='column'
        className={styles.TeacherPageSixthContentStack}
        justifyContent='center'
        alignItems='center'
        sx={{ ...slideBasedOnMarginRight(loadedAnimation, "0%", "-100%") }}
      >
        <Box className={`heading1 ${styles.TeacherPageSixthContentDes}`}>
          Looking for
          <br /> Professional Development Resources?
        </Box>
        <Button
          className={`${styles.TeacherPageSixthContentButton} heading2`}
          onClick={() =>
            navigate(`/${TabNames.ProfessionalLearningResourcePage}`)
          }
        >
          Explore Now
        </Button>
      </Stack>
    </Stack>
  );
};

const TEACHER_FQAS_CONFIG = [
  {
    question: "Why should I join Spark?",
    answer: (
      <div
        id='TPFifthContentAccordion__firstQuestion'
        className='TPFifthContent__Accordion__answer__para'
      >
        Spark offers flexibility in sourcing casual teaching work through our user-friendly mobile app. Teachers have complete control over their calendar and if a teacher needs to cancel a booking they can do this at any time without needing to call the Spark Support Team.
        <br />
        <br />
        We only allow schools to confirm bookings for full days, making it easier for teachers to find work. Spark is a location-based platform, so you can easily find work near you by setting a custom location at any time in the Spark app.
      </div>
    ),
  },
  {
    question: "What documents will I need to register?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        <div>
          To become a Spark Casual Relief Teacher, you will need to provide following identity documents:
        </div>
        <ul>
          <li>Primary ID (Government Issued Document e.g. Drivers Licence)</li>
          <li>Passport or Birth Certificate</li>
          <li>Rights to work in Australia</li>
        </ul>
        <div>
          You will also need to provide teaching accreditation documentation relevant to your state. If you wish to teach in Victoria, you will need to provide the following documents:
        </div>
        <ul>
          <li>VIT accreditation card and number</li>
          <li>Mandatory Reporting - Child Protection Certificate</li>
        </ul>
        <div>
          If you wish to teach in New South Wales, you will need to provide the following documents:
        </div>
        <ul>
          <li>NESA accreditation card and number</li>
          <li>Additional certifications in line with standard NESA accreditation requirements</li>
        </ul>
      </div>
    ),
  },
  {
    question: "How do I become an approved teacher?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        <div>
          To become a Spark Casual Relief Teacher, you need to complete the
          following:
        </div>
        <ol>
          <li>
            Register an account on the mobile application or{" "}
            <span
              style={{ cursor: "pointer", color: "#C465A8" }}
              onClick={() =>
                window.open(`/${TabNames.REGISTER}`, "_self")
              }
            >
              here
            </span>
            .
          </li>
          <li>Complete the registration information and documentation.</li>
          <li>Submit your information for approval.</li>
        </ol>
        <div>
          The app will guide you through this process and if you have any
          question you can visit the{" "}
          <span
            style={{ cursor: "pointer", color: "#C465A8" }}
            onClick={() => window.open(`/${TabNames.HELP_DESK}`, "_self")}
          >
            Help Desk
          </span>{" "}
          at any time.
        </div>
      </div>
    ),
  },
  {
    question: "How long does it take for my account to be approved?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        Once the registration process is complete and the teacher has submitted
        their profile for approval, the approval process typically takes a few
        working days.
        <br />
        <br />
        The process can take additional time if the person nominated as a
        reference does not reply or if the teacher has made a mistake in their
        submission.
        <br />
        <br />
        To ensure an account is approved as quickly as possible we encourage all
        teachers to take their time with the registration and keep an eye on
        their email inbox for clarifications from the Spark Onboarding team.
      </div>
    ),
  },
  {
    question: "Where does Spark operate?",
    answer: (
      <div className='TPFifthContent__Accordion__answer__para'>
        Spark Relief Teachers currently operates in Victoria and New South Wales.
        <br />
        <br />
        If you live elsewhere in Australia, you will still be able to register an account. However, your account cannot be approved until Spark operates in that state and your accreditation is verified against that state's requirements.
      </div>
    ),
  },
];

export const TeacherPageSeventhContent = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const navigate = useNavigate();
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack className='flex_row_center'>
      <Stack
        className={styles.TeacherPageSeventhContent_container}
        direction={screenType === "PC" ? "row" : "column"}
      >
        <Stack className={styles.TeacherPageSeventhContent_leftStack}>
          <Box
            className={`${styles.TeacherPageSeventhContent_title} ${screenType === "PC"
              ? "headLine_large bold_weight"
              : "title_large semi_bold_weight"
              }`}
          >
            Frequently Asked Questions
          </Box>
          <Box sx={{ position: "relative" }}>
            <img
              src={tp_sevenC_img}
              alt='Frequently asked questions for Spark Relief Teachers'
              className={styles.tp_sevenC_img}
            />
            <img
              src={tp_sc_sticker}
              alt='Frequently asked questions for Spark Relief Teachers'
              className={styles.tp_sevenC_img_leftSticker}
            />
            <img
              src={tp_sc_sticker}
              alt='Frequently asked questions for Spark Relief Teachers'
              className={styles.tp_sevenC_img_rightSticker}
            />
          </Box>
        </Stack>
        <Stack
          className={styles.TeacherPageSeventhContent_accordionWrapper}
          sx={{ ...slideBasedOnMarginRight(loadedAnimation, "0px", "-100px") }}
        >
          <StyledAccordion configs={TEACHER_FQAS_CONFIG} />
          <div
            className={`${styles.backButton} title_medium`}
            onClick={() => navigate(`/${TabNames.TEACHER_FAQ}`)}
            style={{ color: "#C465A8" }}
          >
            {"More Teacher FAQ's >"}
          </div>
        </Stack>
      </Stack>
    </Stack>
  );
};

export const TeacherPageEighthContent = ({
  loadedAnimation,
}: IContentWithAnimation) => {
  const screenType = useSelector((state: RootState) => state.ui.screenType);

  return (
    <Stack className='flex_row_center'>
      <Stack
        className={styles.TeacherPageEighthContent}
        direction={screenType === "MOBILE" ? "column" : "row"}
      >
        <Box
          className='title_large semi_bold_weight'
          sx={{ display: screenType === "MOBILE" ? "unset" : "none" }}
        >
          Download the Spark app today!
        </Box>
        <Box className={styles.TeacherPageEighthContent_image_wrapper}>
          <img
            src={TeacherAvailabilityPhone}
            alt='CRT availability calendar in Spark Relief Teachers app'
            className={styles.tp_eighC_device_right}
            style={{
              ...slideBasedOnMarginTop(loadedAnimation, "0px", "100px"),
            }}
          />
          <img
            src={tp_eighC_device_ava}
            alt='CRT bookings in the Spark Relief Teachers app'
            className={styles.tp_eighC_device_left}
            style={{
              ...slideBasedOnMarginTop(loadedAnimation, "0px", "100px"),
              transitionDelay: "0.2s",
            }}
          />
          <img
            src={tp_eighC_leftBottom}
            alt='tp_eighC_leftBottom'
            className={styles.tp_eighC_leftBottom}
          />
          <img
            src={tp_eighC_rightTop}
            alt='tp_eighC_rightTop'
            className={styles.tp_eighC_rightTop}
          />
          <img
            src={tp_eighC_leftCenter}
            alt='tp_eighC_leftCenter'
            className={styles.tp_eighC_leftCenter}
          />
          <img
            src={tp_eigthC_center}
            alt='tp_eigthC_center'
            className={styles.tp_eigthC_center}
          />
        </Box>
        <Stack
          className={styles.TeacherPageEighthContent_rightStack}
          justifyContent='center'
        >
          <Box
            className={` ${screenType === "PC"
              ? "bold_weight display_large"
              : "headLine_large regular_weight"
              } ${styles.tp_eigthC_text}`}
            sx={{
              textAlign: screenType === "PC" ? "right" : "center",
              ...slideBasedOnMarginRight(loadedAnimation, "0px", "-100px"),
            }}
          >
            {screenType === "PC" ? (
              <>
                Download the <br /> Spark app <br /> today!
              </>
            ) : (
              <>
                Download the <br /> Spark app today!
              </>
            )}
          </Box>
          <Stack
            direction={"row"}
            alignItems='center'
            justifyContent='center'
            className={styles.TeacherPageEighthContent_buttonStack}
            sx={{
              ...fadeIn(loadedAnimation),
              ...scaleUP(loadedAnimation),
              ...transitionCubicBezier,
            }}
          >
            <AppleButton></AppleButton>
            <GooglePlayButton></GooglePlayButton>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
